import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import { TestService } from '@ispm/dashboard/test/services/test.service';
import { ClinicalTrialService } from '@ispm/user/services/clinical-trial.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'gen-clinical-trial',
  templateUrl: './clinical-trial.component.html',
  styleUrls: ['./clinical-trial.component.scss'],
})
export class ClinicalTrialsComponent implements OnInit {
  public dashboardLoading: any;
  currentRevision: any;
  noClinicalTrialsMessage: any;
  provider: any;
  clinicalTrials: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private testService: TestService,
    private clinicalTrialService: ClinicalTrialService,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    const currentRevisionId = this.activatedRoute.parent.snapshot.params.revisionId;
    this.clinicalTrialService.getAll(currentRevisionId).subscribe((res) => {
      this.clinicalTrials = res.body;
      if (res.body.length === 0) {
        this.noClinicalTrialsMessage = this.testService.testConfiguration.clinicalTrialsEmptyMessage;
        this.provider = null;
      }
      else {
        this.provider = this.translateService.instant('clinicalTrials.provider');
        this.noClinicalTrialsMessage = null;
      }
      this.cdr.markForCheck();
    });


  }


  public openReference(trialID) {
    const url = 'https://clinicaltrials.gov/ct2/show/' + trialID;
    window.open(url, '_blank');
  }
}
